import {t} from '@github-ui/swp-core/lib/utils/localization'

import {SELECT_LANGUAGE_LABEL, defaultLocaleOptions} from '../marketing-footer.data'
import type {LocaleConfig, LocaleOption, RailsLocaleOption} from '../marketing-footer.types'

function toLocaleOption(entry: RailsLocaleOption): LocaleOption {
  return {
    label: t(entry.displayName),
    locale: entry.selectorLocale,
    analyticsLabel: entry.analyticsLabel,
  }
}

export function buildLocaleConfig(railsOptions: RailsLocaleOption[] | undefined, currentLocale: string): LocaleConfig {
  const options = railsOptions && railsOptions.length > 0 ? railsOptions.map(toLocaleOption) : defaultLocaleOptions()
  const current = options.find(o => o.locale.startsWith(currentLocale.slice(0, 2))) ?? options[0]
  const currentLabel = current ? current.label : t('English')

  return {
    triggerAriaLabel: `${currentLabel} - ${SELECT_LANGUAGE_LABEL()}`,
    options,
    currentLocale: current ? current.locale : 'en-us',
  }
}
